<template>
        <tr v-if="editSerie === false">
            <td cols="1">
                <b-input :hidden="true" type="text" v-model="serie.identifier"></b-input>
                {{ serie.identifier }}
            </td>
            <td>
                {{ serie.descripcion }}
            </td>
            <td>
                <b-form-checkbox disabled v-model="serie.isActive"></b-form-checkbox>
            <td cols="2">
                <b-button v-on:click="editSerie=true" size="sm" variant="outline-secondary" class="mb-2">
                    <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
                    <span class="sr-only">Help</span>
                </b-button>

                <b-button v-on:click="deleteSerie" size="sm" variant="outline-danger" class="mb-2">
                    <b-icon icon="trash" aria-hidden="true"></b-icon>
                    <span class="sr-only">Help</span>
                </b-button>
            </td>
        </tr>
        <!-- EDITA EL REGISTRE -->
        <tr v-else>
             <td cols="1">
                <b-input autofocus v-model="serie.identifier" v-on:keyup.13="updateSerie" v-on:keyup.esc="cancelForm"></b-input>
            </td>
             <td>
                <b-input v-model="serie.descripcion" v-on:keyup.13="updateSerie" v-on:keyup.esc="cancelForm"></b-input>
            </td>
            <td>
                <b-form-checkbox v-model="serie.isActive"></b-form-checkbox>
            </td>
            <td cols="2">
                <b-button v-on:click="updateSerie" size="sm" variant="outline-success" class="mb-2">
                    <b-icon icon="check" aria-hidden="true"></b-icon>
                </b-button>
                <b-button @click="cancelForm" size="sm" variant="outline-dark" class="mb-2">
                    <b-icon icon="x-square" aria-hidden="true"></b-icon>
                </b-button>
            </td>
        </tr>
</template>

<script>
export default {
  props: {
    serie: {
      identifier: {
        type: String,
        required: true
      },
      descripcion: {
        type: String,
        required: true
      },
      isActive: Boolean
    }
  },
  data () {
    return {
      editSerie: false,
      valorInicial: null
    }
  },
  created () {
    this.SerieBeforeEdit = Object.assign({}, this.serie)
  },
  methods: {
    deleteSerie () {
      this.$emit('deleteSerie', this.serie)
    },
    updateSerie () {
      this.editSerie = false
      this.$emit('updateSerie', this.serie)
    },
    cancelForm () {
      Object.assign(this.serie, this.SerieBeforeEdit)
      this.editSerie = false
    }
  }
}
</script>
